<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template>
	<div>
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-icon v-on="on" class="mr-4" ref="button" small @click="log_open = true">far fa-rectangle-history</v-icon>
			</template>
			<span>View Log</span>
		</v-tooltip>

		<div
			v-show="log_open"
			class="log"
			ref="log"
			:style="position"
		>
			<div class="d-flex align-center">
				<div class="title">Asset Log</div>

				<v-spacer/>

				<v-btn color="secondary" dark small @click="log_open = false">
					<v-icon small class="mr-2">fas fa-times</v-icon>
					Done
				</v-btn>
			</div>
			
			<div class="list-container">
				<v-list three-line dense disabled>
					<template v-for="(item, index) in log">
						<v-list-item dense>
							<v-list-item-avatar>
								<v-icon v-if="item.action == 'status'" small>fas fa-arrow-up-right-from-square</v-icon>
								<v-icon v-else small>fas fa-user-magnifying-glass</v-icon>
							</v-list-item-avatar>

							<v-list-item-content>
								<v-list-item-title v-if="item.action == 'status'" class="d-flex">
									<span class="mr-1">{{ get_status_text(item.from) }}</span>
									<v-icon class="mr-1" small>fas fa-arrow-right</v-icon>
									<span>{{ get_status_text(item.to) }}</span>
									<v-spacer/>
									<v-icon v-if="item.to && item.to != 'submitted' && item.to != 'under_review'" small :color="item.paid ? 'green' : 'red'">fas fa-circle-dollar</v-icon>
								</v-list-item-title>

								<v-list-item-title v-else>
									Assigned to: {{ item.assigned_user_name }}
								</v-list-item-title>

								<v-list-item-subtitle>By: {{ item.user_name }}</v-list-item-subtitle>
								<v-list-item-subtitle>On: {{ new Date(item.created_at).toLocaleDateString() }}</v-list-item-subtitle>
							</v-list-item-content>						
						</v-list-item>

						<v-divider
							v-if="index < log.length - 1"
							:key="index"
						/>
					</template>
				</v-list>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import processes from './processes'

export default {
	name: 'Comments',

	props: {
		reference_id: {type: String, required: true}
	},

	data() {
		return {
			log: [],
			log_open: false,
			coordinates: {x: -380, y: 6},
		}
	},

	computed: {
		...mapState(['user_info', 'site_config']),

		position() {
			return {
				transform: `translate(${this.coordinates.x}px, ${this.coordinates.y}px)`
			}
		},

		statuses() {
			let arr = processes[this.site_config.asset_manager_process].general.statuses

			arr.unshift({key: '', text: 'Not Submitted'})

			return arr
		}
	},

	mounted() {
		this.load()
	},

	methods: {
		load() {
			let payload = {
				asset_id: this.reference_id, 
				user_id: this.user_info.user_id
			}

			U.ajax('get_asset_log', payload, result => {
				if (!result.status == 'ok') {
					console.error('something went wrong: ', result)
				} else {
					this.log = result.log
				}
			})
		},

		get_status_text(status) {
			if (!status) status = ''
			let item = this.statuses.filter(x => x.key == status)[0]
			return item.text ?? ''
		}
	}
}
</script>

<style lang="scss" scoped>
.log {
	position: fixed;
	width: 400px;
	height: 400px;
	padding: 16px;
	background-color: white;
	border-radius: 12px;
	box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.125);
	border: 1px solid rgba(0, 0, 0, 0.125);
	z-index: 100000;

	.list-container {
		height: calc(100% - 30px);
		overflow: auto;
		margin-top: 6px;
	}
}
</style>